export default __webpack_public_path__ + "static/media/PopupFreeAccount.1eaf7672.png";